// extracted by mini-css-extract-plugin
export var container = "_98-0";
export var error = "_98-9";
export var label = "_98-5";
export var light = "_98-6";
export var md = "_98-3";
export var sm = "_98-2";
export var thin = "_98-8";
export var thinBold = "_98-7";
export var vertical = "_98-4";
export var xs = "_98-1";